import { isLiabilityType, type AccountSummary, type AccountType } from '@/api/accounts'

export type AccountSide = 'ALL' | 'ASSETS' | 'LIABILITIES'

export interface AccountFilters {
  q: string
  side: AccountSide
  type: AccountType | ''
  hideZero: boolean
  showArchived: boolean
}

export const NO_ACCOUNT_FILTERS: AccountFilters = {
  q: '',
  side: 'ALL',
  type: '',
  hideZero: false,
  showArchived: false,
}

export function matchesAccountFilters(account: AccountSummary, f: AccountFilters): boolean {
  if (account.archivedAt && !f.showArchived) return false
  const q = f.q.trim().toLowerCase()
  if (q && !account.name.toLowerCase().includes(q)) return false
  if (f.side === 'ASSETS' && isLiabilityType(account.type)) return false
  if (f.side === 'LIABILITIES' && !isLiabilityType(account.type)) return false
  if (f.type && account.type !== f.type) return false
  if (f.hideZero && account.balance === 0) return false
  return true
}

export function hasActiveAccountFilters(f: AccountFilters): boolean {
  return f.side !== 'ALL' || f.showArchived || narrowsAccountTotals(f)
}

/** Side only hides a whole section and archived rows never count, so neither changes a section total. */
export function narrowsAccountTotals(f: AccountFilters): boolean {
  return f.q.trim() !== '' || f.type !== '' || f.hideZero
}

/** Null when an older backend omits netWorthValue — the caller falls back to the household total. */
export function visibleSideTotal(accounts: AccountSummary[], peopleAmount: number): number | null {
  let total = peopleAmount
  for (const a of accounts) {
    if (a.archivedAt) continue
    if (a.netWorthValue === undefined) return null
    total += a.netWorthValue
  }
  return total
}
